import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import cookies from 'vue-cookies'
import axios from 'axios'
import jwtDecode from "jwt-decode";
import './registerServiceWorker'
import vuetify from './plugins/vuetify';
import { VueFlowy } from "vue-flowy";
import HighchartsVue from "highcharts-vue";
import Highcharts from "highcharts";
import exportingInit from "highcharts/modules/exporting";
import exportingData from "highcharts/modules/export-data";
import heatmap from "highcharts/modules/heatmap";
import wordcloud from 'highcharts/modules/wordcloud'
import stockInit from 'highcharts/modules/stock'
import hcMore from "highcharts/highcharts-more";
import VueRx from 'vue-rx'
// Use build files
import VuejsClipper from 'vuejs-clipper/dist/vuejs-clipper.umd.min'
import 'vuejs-clipper/dist/vuejs-clipper.css'

Vue.use(VueRx)
Vue.use(VuejsClipper)
hcMore(Highcharts);
stockInit(Highcharts)
heatmap(Highcharts);
wordcloud(Highcharts)
exportingInit(Highcharts);
exportingData(Highcharts);
Vue.use(HighchartsVue);
Vue.component(VueFlowy);

Vue.prototype.$axios = axios
Vue.prototype.$cookies = cookies
Vue.prototype.$jwtDecode = jwtDecode;
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
